import $ from 'jquery';
import { observer } from './lozad'

//init ajax functions
//make sure naming conventiions are consistant in blade file
if ( $( '#news-filter' ).length ) {
  ajax_init( 'news' );
}  

function ajax_init ( cpt ) {

  let ajax_item = {'ajax_url':'\/wp\/wp-admin\/admin-ajax.php'};

  let paged = 1;

  //doing the main filtering, detecting change on checkbox and loading the ajax results
  $('#filters input').on('change', function( e ) {
    e.preventDefault();
    $( this ).parent().parent().find( '.show-all-filter' ).removeClass( 'active' );
    loadResults();
  })

  //clears all filters and reloads all resuts
  $( '.show-all-filter' ).on( 'click', function( e ) {
    e.preventDefault();
    let $this = $( this );
    $this.addClass( 'active' );
    $this.parent().find('.filter input:checkbox').prop( 'checked', false );
    $this.parent().find('.filter input:radio').prop( 'checked', false );
    loadResults();
  })

  //add a listener/callback for the pagination clicks.
  $( '.ajax-page-count' ).on( 'click', '.pagination a', function( e ){
    e.preventDefault();

    let page = this.href;
    paged =getPageFromUrl( page );
    loadResults( paged );
    loadPaginate();
  });

  //uses cpt var to definie container and filter results
  //make sure naming is accurate 
  function loadResults( pageNumber ) {
    let container = $( '#' + cpt + '-container' );
    container.hide().empty();

    let pagination = $( '.pagination' );

    paged = pageNumber || 1;
    let data = $('#' + cpt + '-filter').serialize() + "&paged=" + paged

    $.ajax({
      url: ajax_item.ajax_url,
      data: data,
      success: function (response) {
        container.show().append( response );
        observer.observe();

        // let html = $.parseHTML( response );
        // let postCount = $( html ).find('.cpt-card').length;

        // if ( postCount < 4 ) {
        //   $( '.pagination' ).hide();
        // } else {
        //   $( '.pagination' ).show();
        // }
      },
      error: function (response) {
        console.warn( response );
      }
    })

  }
  function loadPaginate() {

    $.ajax({
      url:"{{ route('partials.includes.news-paginate') }}",
      method:"POST",
  
      data:{
          _token:_token,
          },
      success:function(data)
      {
  
          $('.paginate').empty();
  
          $('.paginate').append(data);
  
      }
  });
  }
}

//gets page number from pagination url
function getPageFromUrl( url ) {
  const match = url.match(/(?:\/page\/|[?&]paged=)([1-9]\d*)/)
  if ( match ) {
    return Number(match[1]);
  }
  return 1;
}